import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';

function Breadcrumb({
  buttonText,
  formData,
  type,
  onSubmittBtn,
  name,
  defaultValues,
  onImageChange,
  showOtherComponent,
  closeUploadCompliance,
}) {
  const [open, setOpen] = useState(false);
  const [otpDialog, setOtpDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);

  const addButton = () => {
    setOpen(true);
    closeUploadCompliance();
  };
  const handleClose = () => {
    setOpen(false);
    setOtpDialog(false);
    setSuccessDialog(false);
  };
  const onDialog = (data, code) => {
    onSubmittBtn(data, code);
    if (type === 'Vehicle') {
      setOpen(true);
    } else {
      setOpen(false);
    }
    setOtpDialog(false); //should be true for otp verification
  };

  const onOtpButton = () => {
    setOtpDialog(false);
    setSuccessDialog(true);
  };

  const breadcrumbPaths = [
    { name: 'City Manager',url:'/citymanager', className: 'colorGrey fontSemi' },
    { name: name, url: '', className: 'colorBlue' },
  ];

  return (
    <div>
      <Grid
        container
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock0"
      >
        <Grid item xs={7}>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
          xs={5}
        >
          <Grid item>
            {buttonText ? (
              <Button
                onClick={() => {
                  addButton();
                }}
                className="btnSubvendorAdd"
              >
                {buttonText}
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
      {type === 'Vehicle' && (
        <CommonMultiImageForm
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'Create'}
          type={type}
          setOpen={false}
          defaultValues={defaultValues}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName={'vehicle'}
        />
      )}

      {open && type !== 'Vehicle' && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={formData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'Create'}
          type={type}
          defaultValues={defaultValues}
        />
      )}
    </div>
  );
}

export default Breadcrumb;
